import { v1 } from "../api";

export async function getReinscripciones({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/reinscripciones`, {
    params,
  });

  return response.data;
}

export async function addReinscripcion({
  empresaId = 0,
  reinscripcion = {},
  archivos = {},
}) {
  const {
    empresa_id,
    registro_ccia_pago_por_inscripcion,
    registro_ccia_multa,
    empresa_cerrada,
    ...data
  } = reinscripcion;

  const formData = new FormData();

  for (const archivo of [...archivos]) {
    formData.append(archivo.name, archivo);
  }

  formData.append("data", JSON.stringify(data));

  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones`,
    formData,
    {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/pdf",
      },
    }
  );

  return response;
}

export async function getReinscripcion({ empresaId = 0, reinscripcionId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}`
  );

  return response.data;
}

export async function updateReinscripcion({
  empresaId = 0,
  reinscripcionId = 0,
  reinscripcion = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}`,
    reinscripcion
  );

  return response;
}

export async function deleteReinscripcion({
  empresaId = 0,
  reinscripcionId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}`
  );

  return response;
}

// detalles por reinscripción
export async function getDetalles({ empresaId = 0, reinscripcionId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles`
  );

  return response.data;
}

export async function addDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalle = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles`,
    detalle
  );

  return response;
}

export async function getDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalleId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles/${detalleId}`
  );

  return response.data;
}

export async function updateDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalleId = 0,
  detalle = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles/${detalleId}`,
    detalle
  );

  return response;
}

export async function deleteDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalleId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles/${detalleId}`
  );

  return response;
}

export async function verifyDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalleId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles/${detalleId}/verify`
  );

  return response;
}

export async function validateDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalleId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles/${detalleId}/validate`
  );

  return response;
}

export async function invalidateDetalle({
  empresaId = 0,
  reinscripcionId = 0,
  detalleId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/detalles/${detalleId}/invalidate`
  );

  return response;
}

// establecimientos por reinscripción
export async function getEstablecimientos({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/establecimientos`,
    { params }
  );

  return response.data;
}

export async function addEstablecimiento({
  empresaId = 0,
  reinscripcionId = 0,
  establecimiento = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/establecimientos`,
    establecimiento
  );

  return response;
}

export async function getEstablecimiento({
  empresaId = 0,
  reinscripcionId = 0,
  establecimientoId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/establecimientos/${establecimientoId}`
  );

  return response.data;
}

export async function updateEstablecimiento({
  empresaId = 0,
  reinscripcionId = 0,
  establecimientoId = 0,
  establecimiento = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/establecimientos/${establecimientoId}`,
    establecimiento
  );

  return response;
}

export async function deleteEstablecimiento({
  empresaId = 0,
  reinscripcionId = 0,
  establecimientoId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/establecimientos/${establecimientoId}`
  );

  return response;
}

export async function verifyEstablecimiento({
  empresaId = 0,
  reinscripcionId = 0,
  establecimientoId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/establecimientos/${establecimientoId}/verify`
  );

  return response;
}

// telefonos por reinscripción
export async function getTelefonos({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/telefonos`,
    { params }
  );

  return response.data;
}

export async function addTelefono({
  empresaId = 0,
  reinscripcionId = 0,
  telefono = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/telefonos`,
    telefono
  );

  return response;
}

export async function getTelefono({
  empresaId = 0,
  reinscripcionId = 0,
  telefonoId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/telefonos/${telefonoId}`
  );

  return response.data;
}

export async function updateTelefono({
  empresaId = 0,
  reinscripcionId = 0,
  telefonoId = 0,
  telefono = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/telefonos/${telefonoId}`,
    telefono
  );

  return response;
}

export async function deleteTelefono({
  empresaId = 0,
  reinscripcionId = 0,
  telefonoId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/telefonos/${telefonoId}`
  );

  return response;
}

export async function verifyTelefono({
  empresaId = 0,
  reinscripcionId = 0,
  telefonoId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/telefonos/${telefonoId}/verify`
  );

  return response;
}

// celulares por reinscripción
export async function getCelulares({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/celulares`,
    { params }
  );

  return response.data;
}

export async function addCelular({
  empresaId = 0,
  reinscripcionId = 0,
  celular = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/celulares`,
    celular
  );

  return response;
}

export async function getCelular({
  empresaId = 0,
  reinscripcionId = 0,
  celularId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/celulares/${celularId}`
  );

  return response.data;
}

export async function updateCelular({
  empresaId = 0,
  reinscripcionId = 0,
  celularId = 0,
  celular = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/celulares/${celularId}`,
    celular
  );

  return response;
}

export async function deleteCelular({
  empresaId = 0,
  reinscripcionId = 0,
  celularId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/celulares/${celularId}`
  );

  return response;
}

export async function verifyCelular({
  empresaId = 0,
  reinscripcionId = 0,
  celularId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/celulares/${celularId}/verify`
  );

  return response;
}

// correos electrónicos por reinscripción
export async function getCorreosElectronicos({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/correos-electronicos`,
    { params }
  );

  return response.data;
}

export async function addCorreoElectronico({
  empresaId = 0,
  reinscripcionId = 0,
  correoElectronico = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/correos-electronicos`,
    correoElectronico
  );

  return response;
}

export async function getCorreoElectronico({
  empresaId = 0,
  reinscripcionId = 0,
  correoElectronicoId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/correos-electronicos/${correoElectronicoId}`
  );

  return response.data;
}

export async function updateCorreoElectronico({
  empresaId = 0,
  reinscripcionId = 0,
  correoElectronicoId = 0,
  correoElectronico = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/correos-electronicos/${correoElectronicoId}`,
    correoElectronico
  );

  return response;
}

export async function deleteCorreoElectronico({
  empresaId = 0,
  reinscripcionId = 0,
  correoElectronicoId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/correos-electronicos/${correoElectronicoId}`
  );

  return response;
}

export async function verifyCorreoElectronico({
  empresaId = 0,
  reinscripcionId = 0,
  correoElectronicoId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/correos-electronicos/${correoElectronicoId}/verify`
  );

  return response;
}

// páginas web por reinscripción
export async function getPaginasWeb({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/paginas-web`,
    { params }
  );

  return response.data;
}

export async function addPaginaWeb({
  empresaId = 0,
  reinscripcionId = 0,
  paginaWeb = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/paginas-web`,
    paginaWeb
  );

  return response;
}

export async function getPaginaWeb({
  empresaId = 0,
  reinscripcionId = 0,
  paginaWebId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/paginas-web/${paginaWebId}`
  );

  return response.data;
}

export async function updatePaginaWeb({
  empresaId = 0,
  reinscripcionId = 0,
  paginaWebId = 0,
  paginaWeb = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/paginas-web/${paginaWebId}`,
    paginaWeb
  );

  return response;
}

export async function deletePaginaWeb({
  empresaId = 0,
  reinscripcionId = 0,
  paginaWebId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/paginas-web/${paginaWebId}`
  );

  return response;
}

export async function verifyPaginaWeb({
  empresaId = 0,
  reinscripcionId = 0,
  paginaWebId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/paginas-web/${paginaWebId}/verify`
  );

  return response;
}

// encargados por reinscripción
export async function getEncargados({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/encargados`,
    { params }
  );

  return response.data;
}

export async function addEncargado({
  empresaId = 0,
  reinscripcionId = 0,
  encargado = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/encargados`,
    encargado
  );

  return response;
}

export async function getEncargado({
  empresaId = 0,
  reinscripcionId = 0,
  encargadoId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/encargados/${encargadoId}`
  );

  return response.data;
}

export async function updateEncargado({
  empresaId = 0,
  reinscripcionId = 0,
  encargadoId = 0,
  encargado = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/encargados/${encargadoId}`,
    encargado
  );

  return response;
}

export async function deleteEncargado({
  empresaId = 0,
  reinscripcionId = 0,
  encargadoId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/encargados/${encargadoId}`
  );

  return response;
}

export async function verifyEncargado({
  empresaId = 0,
  reinscripcionId = 0,
  encargadoId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/encargados/${encargadoId}/verify`
  );

  return response;
}

// actividades económicas por reinscripción
export async function getActividadesEconomicas({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/actividades-economicas`,
    { params }
  );

  return response.data;
}

export async function addActividadEconomica({
  empresaId = 0,
  reinscripcionId = 0,
  actividadEconomica = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/actividades-economicas`,
    actividadEconomica
  );

  return response;
}

export async function getActividadEconomica({
  empresaId = 0,
  reinscripcionId = 0,
  actividadId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/actividades-economicas/${actividadId}`
  );

  return response.data;
}

export async function updateActividadEconomica({
  empresaId = 0,
  reinscripcionId = 0,
  actividadId = 0,
  actividadEconomica = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/actividades-economicas/${actividadId}`,
    actividadEconomica
  );

  return response;
}

export async function deleteActividadEconomica({
  empresaId = 0,
  reinscripcionId = 0,
  actividadId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/actividades-economicas/${actividadId}`
  );

  return response;
}

export async function verifyActividadEconomica({
  empresaId = 0,
  reinscripcionId = 0,
  actividadId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/actividades-economicas/${actividadId}/verify`
  );

  return response;
}

// importaciones por reinscripción
export async function getImportaciones({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/importaciones`,
    { params }
  );

  return response.data;
}

export async function addImportacion({
  empresaId = 0,
  reinscripcionId = 0,
  importacion = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/importaciones`,
    importacion
  );

  return response;
}

export async function getImportacion({
  empresaId = 0,
  reinscripcionId = 0,
  importacionId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/importaciones/${importacionId}`
  );

  return response.data;
}

export async function updateImportacion({
  empresaId = 0,
  reinscripcionId = 0,
  importacionId = 0,
  importacion = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/importaciones/${importacionId}`,
    importacion
  );

  return response;
}

export async function deleteImportacion({
  empresaId = 0,
  reinscripcionId = 0,
  importacionId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/importaciones/${importacionId}`
  );

  return response;
}

export async function verifyImportacion({
  empresaId = 0,
  reinscripcionId = 0,
  importacionId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/importaciones/${importacionId}/verify`
  );

  return response;
}

// exportaciones por reinscripción
export async function getExportaciones({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/exportaciones`,
    { params }
  );

  return response.data;
}

export async function addExportacion({
  empresaId = 0,
  reinscripcionId = 0,
  exportacion = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/exportaciones`,
    exportacion
  );

  return response;
}

export async function getExportacion({
  empresaId = 0,
  reinscripcionId = 0,
  exportacionId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/exportaciones/${exportacionId}`
  );

  return response.data;
}

export async function updateExportacion({
  empresaId = 0,
  reinscripcionId = 0,
  exportacionId = 0,
  exportacion = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/exportaciones/${exportacionId}`,
    exportacion
  );

  return response;
}

export async function deleteExportacion({
  empresaId = 0,
  reinscripcionId = 0,
  exportacionId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/exportaciones/${exportacionId}`
  );

  return response;
}

export async function verifyExportacion({
  empresaId = 0,
  reinscripcionId = 0,
  exportacionId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/exportaciones/${exportacionId}/verify`
  );

  return response;
}

// archivos por reinscripción
export async function getArchivos({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/archivos`,
    { params }
  );

  return response.data;
}

export async function addArchivos({
  empresaId = 0,
  reinscripcionId = 0,
  archivos = {},
}) {
  const formData = new FormData();

  for (const archivo of [...archivos]) {
    formData.append(archivo.name, archivo);
  }

  const response = await v1.post(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/archivos`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response;
}

export async function deleteArchivo({
  empresaId = 0,
  reinscripcionId = 0,
  filename = "",
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/archivos/${filename}`
  );

  return response;
}

// formatos
export async function getFormatos({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/formatos`,
    { params }
  );

  return response.data;
}

export async function getHojaDeReinscripcion({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/formatos/hoja-de-reinscripcion`,
    {
      params,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/pdf",
      },
    }
  );

  return response.data;
}

export async function getDiplomaReinscripcion({
  empresaId = 0,
  reinscripcionId = 0,
  params = {},
}) {
  const response = await v1.get(
    `empresas/${empresaId}/reinscripciones/${reinscripcionId}/formatos/diploma-de-reinscripcion`,
    {
      params,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/pdf",
      },
    }
  );

  return response;
}
